import React from "react";
import $ from "jquery";
import leftPng from "../../../../content/images/left.png";
import dateTimePng from "../../../../content/images/date-time.png";
import * as omnimap from "../../../../api/omnimap/omnimapActions";
import * as CallBackFunctions from "./functions/callBackFunctions";
import * as GC from "../../../common/common";
import { connect } from "react-redux";
import { SaveOrUpdate } from "../../../../redux/actions/catalogManagementUnitsAction";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";

class Edit extends React.Component {
  constructor(props) {
    super(props);
    this.rowId =
      this.props.match &&
      this.props.match.params &&
      this.props.match.params.rowId;
    this.state = {
      code: this.props.history.location.state.rowData.code,
      wetenschappelijke:
        this.props.history.location.state.rowData.wetenschappelijkenaam,
      nederlandse: this.props.history.location.state.rowData.nederlandsenaam,
      soort: this.props.history.location.state.rowData.soort,
      startPeriode: this.props.history.location.state.rowData.startperiode,
      eindePeriode: this.props.history.location.state.rowData.eindeperiode,
      wet: this.props.history.location.state.rowData.wet,
      naamPeriode: this.props.history.location.state.rowData.naamperiode,
      omschrijving: this.props.history.location.state.rowData.omschrijving,
      ovg: this.props.history.location.state.rowData.ovg,
      active: this.props.history.location.state.rowData.actief,
      codeRequiredAlert: false,
      wetenschappelijkeRequiredAlert: false,
      nederlandseRequiredAlert: false,
      soortRequiredAlert: false,
      eindePeriodeRequiredAlert: false,
      startPeriodeRequiredAlert: false,
      wetRequiredAlert: false,
      naamPeriodeRequiredAlert: false,
      omschrijvingRequiredAlert: false,
    };
    this.rowData = this.props.history.location.state.rowData;
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });

    if (value != "" && name == "code") {
      this.setState({ codeRequiredAlert: false });
    }
    if (value != "" && name == "wetenschappelijke") {
      this.setState({ wetenschappelijkeRequiredAlert: false });
    }
    if (value != "" && name == "nederlandse") {
      this.setState({ nederlandseRequiredAlert: false });
    }
    if (value != "" && name == "soort") {
      this.setState({ soortRequiredAlert: false });
    }
    if (value != "" && name == "startPeriode") {
      this.setState({ eindePeriodeRequiredAlert: false });
    }
    if (value != "" && name == "eindePeriode") {
      this.setState({ eindePeriodeRequiredAlert: false });
    }
    if (value != "" && name == "wet") {
      this.setState({ wetRequiredAlert: false });
    }
    if (value != "" && name == "naamPeriode") {
      this.setState({ naamPeriodeRequiredAlert: false });
    }
    if (value != "" && name == "omschrijving") {
      this.setState({ omschrijvingRequiredAlert: false });
    }
  }

  handleSubmit = async () => {
    $("#cover-spin").show(0);
    //
    const { actions } = this.props;

    this.state.code == ""
      ? await this.setState({ codeRequiredAlert: true })
      : await this.setState({ codeRequiredAlert: false });
    this.state.wetenschappelijke == ""
      ? await this.setState({ wetenschappelijkeRequiredAlert: true })
      : await this.setState({ wetenschappelijkeRequiredAlert: false });
    this.state.nederlandse == ""
      ? await this.setState({ nederlandseRequiredAlert: true })
      : await this.setState({ nederlandseRequiredAlert: false });
    this.state.soort == ""
      ? await this.setState({ soortRequiredAlert: true })
      : await this.setState({ soortRequiredAlert: false });
    this.state.eindePeriode == ""
      ? await this.setState({ eindePeriodeRequiredAlert: true })
      : await this.setState({ eindePeriodeRequiredAlert: false });
    this.state.startPeriode == ""
      ? await this.setState({ startPeriodeRequiredAlert: true })
      : await this.setState({ startPeriodeRequiredAlert: false });
    this.state.wet == ""
      ? await this.setState({ wetRequiredAlert: true })
      : await this.setState({ wetRequiredAlert: false });
    this.state.naamPeriode == ""
      ? await this.setState({ naamPeriodeRequiredAlert: true })
      : await this.setState({ naamPeriodeRequiredAlert: false });
    this.state.omschrijving == ""
      ? await this.setState({ omschrijvingRequiredAlert: true })
      : await this.setState({ omschrijvingRequiredAlert: false });
    var model = {
      relationships: { definition: { code: "NATUURBESCHERMING" } },
      content: {
        algemeen: {
          actief: this.state.active,
          code: this.state.code,
          wetenschappelijkenaam: this.state.wetenschappelijke,
          nederlandsenaam: this.state.nederlandse,
          soort: this.state.soort,
          eindeperiode: this.state.eindePeriode,
          startperiode: this.state.startPeriode,
          wet: this.state.wet,
          naamperiode: this.state.naamPeriode,
          omschrijving: this.state.omschrijving,
        },
      },
      identification: this.rowId,
    };

    let isUnique = true;
    let uniqueModel = {
      content: [
        {
          and_or: "AND",
          datatype: "STRING",
          key: "algemeen-code",
          values: [this.state.code],
        },
      ],
      definitions: [process.env.REACT_APP_CATALOG_M_UNITS],
      sorting: [],
    };

    //** code isunique control.
    await omnimap
      .FillTableAction(uniqueModel, 1, window.$catalog_management_units_token)
      .then(async (result) => {
        if (
          result.data &&
          result.data.length > 0 &&
          result.data[0].identification !== this.rowId
        ) {
          isUnique = await false;
          $("#cover-spin").hide(0);

          alert("code is not unique");
        }
      });

    if (
      !this.state.codeRequiredAlert &&
      !this.state.wetenschappelijkeRequiredAlert &&
      !this.state.nederlandseRequiredAlert &&
      !this.state.soortRequiredAlert &&
      !this.state.eindePeriodeRequiredAlert &&
      !this.state.startPeriodeRequiredAlert &&
      !this.state.wetenschappelijkeRequiredAlert &&
      !this.state.naamPeriodeRequiredAlert &&
      !this.state.omschrijvingRequiredAlert &&
      isUnique === true
    ) {
      actions
        .SaveOrUpdate(
          model,
          "PATCH",
          this.rowId,
          window.$catalog_management_units_token
        )
        .then(() => {
          CallBackFunctions.BeheereenheidEditCallBack();
          this.props.history.push("/catalog/nature-protection/");
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      $("#cover-spin").hide(0);
    }
  };

  async componentDidMount() {
    const { actions } = this.props;
  }

  render() {
    return (
      <div id="editSide" /*className="d-none"*/>
        <div className="detail-title">Beheereenheid in edit</div>
        <div className="clearfix">
          <div className="float-left mt-4">
            <a
              id="detail-button"
              className="back-page-link"
              role="button"
              onClick={() => {
                this.props.history.push("/catalog/nature-protection");
              }}
            >
              <img src={leftPng} width={9} height={12} /> &nbsp;Terug naar
              Natuurbescherming
            </a>
          </div>
          <div className="float-right mt-0">
            <a onClick={this.handleSubmit.bind(this)} className="button ok">
              Opslaan
            </a>
          </div>
          <div className="float-right mt-0 w-20">
            <a
              onClick={() => {
                this.props.history.push(
                  "/catalog/nature-protection/detail/" + this.rowId,
                  {
                    rowData: this.rowData,
                  }
                );
              }}
              className="button back"
            >
              Annuleren
            </a>
          </div>
        </div>

        <div className="row clearfix">
          <div className="col-lg-4 text-center">
            <div className="box-detail-active">
              <div className="box-title-1-active">Wetenschappelijke naam</div>
              <div className="box-title-2-active">
                <input
                  autocomplete="off"
                  name="code"
                  value={this.state.code}
                  onChange={this.handleInputChange}
                />
              </div>
            </div>
          </div>
          <div className="col-lg-4 text-center">
            <div className="box-detail">
              <div className="box-title-1">Nederlandse naam</div>
              <div className="box-title-2">
                <input
                  autocomplete="off"
                  name="nederlandse"
                  value={this.state.nederlandse}
                  onChange={this.handleInputChange}
                />
              </div>
            </div>
          </div>
          <div className="col-lg-4 text-center">
            <div className="box-detail">
              <div className="box-title-1">Wet</div>
              <div className="box-title-2">
                <input
                  autocomplete="off"
                  name="wet"
                  value={this.state.wet}
                  onChange={this.handleInputChange}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="row clearfix">
          <div className="col-lg-4 text-center">
            <div className="box-detail">
              <div className="box-title-1">Overige status</div>
              <div className="box-title-2">
                <input
                  autocomplete="off"
                  name="ovg"
                  value={this.state.ovg}
                  onChange={this.handleInputChange}
                />
              </div>
            </div>
          </div>
          <div className="col-lg-4 text-center">
            <div className="box-detail">
              <div className="box-title-1">Naam periode</div>
              <div className="box-title-2">
                <input
                  autocomplete="off"
                  name="naamPeriode"
                  value={this.state.naamPeriode}
                  onChange={this.handleInputChange}
                />
              </div>
            </div>
          </div>
          <div className="col-lg-4 text-center">
            <div className="box-detail">
              <div className="box-title-1">Soort</div>
              <div className="box-title-2">
                <input
                  autocomplete="off"
                  name="soort"
                  value={this.state.soort}
                  onChange={this.handleInputChange}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="row clearfix">
          <div className="col-lg-4 text-center">
            <div className="box-detail">
              <div className="box-title-1">Begin periode</div>
              <div className="box-title-2">
                <input
                  autocomplete="off"
                  name="startPeriode"
                  value={this.state.startPeriode}
                  onChange={this.handleInputChange}
                />
              </div>
            </div>
          </div>
          <div className="col-lg-4 text-center">
            <div className="box-detail">
              <div className="box-title-1">Einde periode</div>
              <div className="box-title-2">
                <input
                  autocomplete="off"
                  name="eindePeriode"
                  value={this.state.eindePeriode}
                  onChange={this.handleInputChange}
                />
              </div>
            </div>
          </div>
          <div className="col-lg-4 text-center">
            <div className="box-detail">
              <div className="box-title-1">Actief</div>
              <label className="switch">
                <input
                  type="checkbox"
                  name="active"
                  onChange={this.handleInputChange}
                  checked={this.state.active ? true : false}
                />
                <span className="slider-checkbox round" />
              </label>
            </div>
          </div>
        </div>

        <input hidden id="e-identification" />
      </div>
    );
  }
}

// export default Edit;
Edit.propTypes = {
  SaveOrUpdate: PropTypes.func.isRequired,
};
function mapStateToProps(state, ownProps) {
  return {
    catalogManagementUnits: state.rowData,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: {
      SaveOrUpdate: bindActionCreators(SaveOrUpdate, dispatch),
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Edit);
